import React, { useEffect, useState } from "react";
import BlogCard from "../components/blog/BlogCard";
import useBlogCalls from "../service/useBlogCalls";
import { useSelector } from "react-redux";
import { Grid, Pagination, PaginationItem } from "@mui/material";
import Category from "../components/Category";
import useNewsCalls from "../service/useNewsCalls";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { makeStyles } from "@material-ui/core/styles";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { Helmet } from "react-helmet";

const Home = () => {
  const { getData } = useBlogCalls();
  const { token, userId } = useSelector((state) => state.auth);

  const { blogs } = useSelector((state) => state.blog);
  console.log("🚀 ~ Home ~ blogs:", blogs);
  const { news } = useSelector((state) => state.news);
  console.log("🚀 ~ Home ~ news:", news);
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiPaginationItem-page.Mui-selected": {
        color: "white", // Seçili sayfa metin rengi
      },
      "& .MuiPaginationItem-page:hover": {
        color: "white", // Üzerine gelindiğinde metin rengi
      },
      "& .MuiPaginationItem-page": {
        color: "white", // Diğer sayfaların metin rengi
      },
      "& .MuiSvgIcon-root": {
        fill: "white", // İkonların rengi
      },
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    getData("blogs", page);
  }, [page]);

  return (
    <>
      <Helmet>
        <title>HomePage | Blogia</title>
        <meta name="description" content="homepage description" />
      </Helmet>
      <div className="home" style={{ padding: "1rem" }}>
        <div
          className="homeTitle"
          style={{
            padding: "1rem",
            width: "80%",
            color: "white",
            backgroundColor: "#2b2d42",
            borderRadius: "10px",
            margin: "auto",
            boxShadow: "-10px -5px -20px -40px white",
          }}
        >
          <h3
            className="home-title"
            style={{
              padding: "1rem",
              textAlign: "center",
              fontFamily: "Times New Roman",
            }}
          >
            IF YOU ARE NOT WILLING TO LEARN, NO ONE CAN HELP YOU, IF YOU ARE
            DETERMINED TO LEARN NO ONE CAN STOP YOU.
          </h3>
        </div>
        <Grid
          // style={{ backgroundColor: "black", }}
          container
          pt={3}
          pl={3}
          spacing={2}
          justifyContent="center" // Ana Grid bileşeninin yatay hizalamasını sağlar
          alignItems="Flex-start " // Ana Grid bileşeninin dikey hizalamasını sağlar
        >
          <Grid item xs={12} lg={8} mt={4.5} container justifyContent="center">
            {blogs?.map((item, i) => (
              <Grid item xs={12} md={6} key={i}>
                <BlogCard item={item} />
              </Grid>
            ))}
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Pagination
                defaultPage={6}
                boundaryCount={1}
                count={10}
                page={page}
                onChange={handleChange}
                color="error"
                className={classes.root}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: SkipPreviousIcon,
                      next: SkipNextIcon,
                    }}
                    {...item}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={4}
            style={{ position: "sticky", top: 0 }}
            justifyContent="center"
          >
            {" "}
            {/* Orta ve tam ortalandı */}
            <Category />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Home;
